export default function MarQuote() {
  return (
    <section className="band quote" id="cita">
      <figure className="wrap">
        <p className="q-mark" aria-hidden="true">“</p>
        <blockquote>
          Una marca clara no sólo se ve mejor:
          <br />se vende mejor, se delega mejor
          <br />y crece con menos esfuerzo.
        </blockquote>
        <figcaption>Coressen Capital™ · Founder</figcaption>
      </figure>
    </section>
  );
}
